<h3>{{ 'orders.reportRequestedFor' | transloco }}</h3>
<div class="margin-bottom-5">
  <div class="flex-container">
    <span class="flex-item-3">{{ 'orders.name' | transloco }}</span>
    <span class="flex-item-4" data-testid="attestor-first-name-text">{{
      order.ultimateBeneficialOwnershipRequest?.entityName }}</span>
  </div>
  @if (order.ultimateBeneficialOwnershipRequest?.entityNumber) {
  <div class="flex-container">
    <span class="flex-item-3">{{ 'orders.number' | transloco }}</span>
    <span class="flex-item-4" data-testid="attestor-middle-name-text">{{
      order.ultimateBeneficialOwnershipRequest!.entityNumber }}</span>
  </div>
  }
</div>

<form [formGroup]="ultimateBeneficialOwnershipDetails">
  @if (showDisplayedCorpNameField()) {
  <h3>{{ 'orders.requestingCorporation' | transloco }}</h3>
  <div class="validated-form-field-container flex-container">
    <div class="padding-top-bottom flex-container">
      <mat-form-field class="flex-item form-field" appearance="outline">
        <mat-label>{{ 'orders.corporationNameToDisplayInAttestation' | transloco }}</mat-label>
        <input matInput [formControlName]="'displayedCorpName'" data-testid="displayedCorpName" [placeholder]="'orders.displayName' | transloco">
      </mat-form-field>
      <lib-error-bubble [control]="ultimateBeneficialOwnershipDetails.controls['displayedCorpName']"
          [message]="displayNameError$"></lib-error-bubble>
    </div>
  </div>
  @if (reusableSecuredParties.length > 0) {
  <div class="padding-top-bottom flex-container">
    <lib-handle-existing-party
      [existingParties]="this.reusableSecuredParties"
      [country]="this.order.country"
      [jurisdiction]="this.order.jurisdiction"
      [buttonText]="'orders.useReusableParty' | transloco"
      (existingPartySavedEvent)="useReusableSecuredParty($event)"
      class="flex-item">
    </lib-handle-existing-party>
  </div>
  }
  }
  @if (showBrandDropdown()) {
  <h3>{{ 'orders.branding' | transloco }}</h3>
  <div class="validated-form-field-container flex-container">
    <div class="padding-top-bottom flex-container">
      <mat-form-field class="flex-item form-field" appearance="outline">
        <mat-label>{{ 'orders.brand2' | transloco }}</mat-label>
        <mat-select [formControlName]="'brandID'" data-testid="brand-select" panelClass="brand-select-panel">
          <mat-option [value]="null">{{ 'orders.default' | transloco }}</mat-option>
          @for (brand of brands; track brand.id) {
          <mat-option [value]="brand.id">
            <span class="brand-option-name">{{ brand.name }}</span>
            @if (brandLogoUrls[brand.id]) {
            <img class="brand-option-logo" [src]="brandLogoUrls[brand.id]" alt="" />
            } @else if (brand.hexCode) {
            <span class="brand-swatch" [style.background-color]="'#' + brand.hexCode"></span>
            }
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  }
  <h3>{{ isFormEnabled ? "Attestor Information" : "Attestor Information Review" }}</h3>
  <div class="padding-top-bottom">
    <div class="validated-form-field-container flex-container">
    @if (shouldShowOneNameOnlyOption()){
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-checkbox class="flex-item" [formControlName]="'hasOneNameOnly'"
           (change)="toggleHasOneName()"
           data-testid="attestor-one-name-only-checkbox">
            {{ 'orders.attestorHasOneNameOnly' | transloco }}
          </mat-checkbox>
        </div>
      </div>
    }
    @if (showTextMessageInFrenchCheckbox()){
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-checkbox class="flex-item" [formControlName]="'sendTextInFrench'"
           data-testid="attestor-send-text-in-french-checkbox">
            {{ 'orders.sendTextMessageInFrench' | transloco }}
          </mat-checkbox>
        </div>
      </div>
    }
  </div>
    <div class="validated-form-field-container flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
          <input matInput [formControlName]="'attestorFirstName'" data-testid="attestor-first-name" [placeholder]="'common.labels.firstName' | transloco">
        </mat-form-field>
        <lib-error-bubble [control]="ultimateBeneficialOwnershipDetails.controls['attestorFirstName']"
          [message]="firstNameError$"></lib-error-bubble>
      </div>

      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
          <input matInput [formControlName]="'attestorMiddleName'" data-testid="attestor-middle-name" [placeholder]="'common.labels.middleName' | transloco">
        </mat-form-field>
      </div>

      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
          <input matInput [formControlName]="'attestorLastName'" data-testid="attestor-last-name" [placeholder]="'common.labels.lastName' | transloco">
        </mat-form-field>
        <lib-error-bubble [control]="ultimateBeneficialOwnershipDetails.controls['attestorLastName']"
          [message]="lastNameError$"></lib-error-bubble>
      </div>

    </div>
    @if (showEmail()) {
    <div class="validated-form-field-container flex-container">
      <mat-form-field class="flex-item form-field" appearance="outline">
        <mat-label>{{ 'common.labels.email' | transloco }}</mat-label>
        <input matInput [formControlName]="'attestorEmail'" data-testid="attestor-email" [placeholder]="'common.labels.email' | transloco">
      </mat-form-field>
      <lib-error-bubble [control]="ultimateBeneficialOwnershipDetails.controls['attestorEmail']"
        [message]="emailError$"></lib-error-bubble>
    </div>
    }
    @if(showAttestorPersonalInfoFields()) {
    <div class="validated-form-field-container flex-container">
      <mat-form-field class="flex-item form-field" appearance="outline">
        <mat-label>{{ 'orders.personalCellPhoneNumber' | transloco }}</mat-label>
        <input matInput [formControlName]="'attestorPhoneNumber'" data-testid="attestor-phone-number" [placeholder]="'orders.phoneNumber2' | transloco">
      </mat-form-field>
      <lib-error-bubble [control]="ultimateBeneficialOwnershipDetails.controls['attestorPhoneNumber']"
        [message]="phoneNumberError$"></lib-error-bubble>
        
      <mat-form-field appearance="outline" class="flex-item-2">
        <mat-label>{{ 'common.labels.dateOfBirth' | transloco }}</mat-label>
        <input matInput [matDatepicker]="dobPicker" formControlName="attestorDateOfBirth" data-testid="attestor-date-of-birth" [placeholder]="'common.labels.yyyyMmDd' | transloco" />
        <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
        <mat-datepicker #dobPicker startView="multi-year"></mat-datepicker>
      </mat-form-field>
      <lib-error-bubble [control]="ultimateBeneficialOwnershipDetails.controls['attestorDateOfBirth']"
      [message]="dobError$"></lib-error-bubble>
    </div>
    }
    @if (showAttestorAddressFields()) {
    <lib-address-form [address]="$safeNavigationMigration(order.parties?.at(0)?.contactDetails?.address)"
      [formLabel]="'orders.currentAddress' | transloco"></lib-address-form>
    }
  </div>
</form>